import { SVGProps } from 'react';

const ParagraphShortIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="4" y="9.25" width="16" height="1.5" fill="#7C612E" />
    <path d="M4 13.25H13V14.75H4V13.25Z" fill="#7C612E" />
  </svg>
);

export default ParagraphShortIcon;
